import { orderBy } from 'lodash';
import { BuildTypeCode } from '../projects/project';
import { PipeResponse } from '../shared/pipes/pipeResponse';
import { DataForQuoteOrDesignForm } from '../shared/quote-or-design-form/GetDataForQuoteOrDesignForm';
import { ThermostatTypeCode } from '../shared/quote-or-design-form/quoteOrDesignFormData';
import { mapUnitResponseToFormModel, UnitResponse } from '../shared/units/unitResponse';
import { QuoteFormModel } from './quote-form/quoteFormModel';

export type QuoteResponse = {
  quoteId: number;
  useLegacyPricingModel: boolean;
  customerId: number;
  name: string;
  isDraft: boolean;
  isSubmitted: boolean;
  hasBillOfMaterials: boolean;
  thermostatTypeCode: ThermostatTypeCode;
  includeNeoHub: boolean;
  units: Array<UnitResponse>;
  pipes: Array<PipeResponse>;
};

export const mapQuoteResponseToQuoteFormModel = (
  quoteResponse: QuoteResponse,
  referenceData: DataForQuoteOrDesignForm,
  projectBuildType: BuildTypeCode,
): QuoteFormModel => ({
  quoteId: quoteResponse.quoteId,
  useLegacyPricingModel: quoteResponse.useLegacyPricingModel,
  name: quoteResponse.name,
  customerId: quoteResponse.customerId,
  isDraft: quoteResponse.isDraft,
  thermostatTypeCode: quoteResponse.thermostatTypeCode,
  includeNeoHub: quoteResponse.includeNeoHub,
  units: orderBy(quoteResponse.units, unit => unit.displayIndex).map(unitResponse =>
    mapUnitResponseToFormModel({
      unitResponse,
      referenceData,
      projectBuildType,
      mapRoomlessManifoldDetailsToRoom: false,
      createDesignDetails: false,
    }),
  ),
  focusedUnitId: null,
  unitsValidation: null,
});
